module.exports = require("core-js/library/fn/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/get-own-property-symbols.js
// module id = 13
// module chunks = 101